export class log_output{
    public log: log_details;
    public proyect: proyect_details;
    public client: client_details;
    public secret_word: string = 'c38Lg64%Y2f2';
    constructor(proyect: string, document: string, method: string, tp: string, message: string, cn: string, cu: string, sn: string){
        this.log = new log_details(tp, message);
        this.proyect = new proyect_details(proyect, document, method);
        this.client = new client_details(cn, cu, sn);
    }
}
export class log_details{
    public type: string;
    public message: string;
    constructor(tp: string, ms: string){
        this.type = tp; this.message = ms;
    }
}
export class proyect_details{
    public proyect_name: string;
    public document_name: string;
    public method_name: string;
    constructor(pn: string, dn: string, mn: string){
        this.proyect_name = pn; this.document_name = dn; this.method_name = mn;
    }
}
export class client_details{
    public client_name: string;
    public client_url: string;
    public service_name: string;
    constructor(cn: string, cu: string, sn: string){
        this.client_name = cn; this.client_url = cu; this.service_name = sn;
    }
}


// WEBPACK FOOTER //
// ./src/app/visualis/models/log.ts